import React from "react";
import { AppShellLogo, BUILD_INFO, JsonExportButton, NavGlyph, StatusGlyph } from "./ui.jsx";

export const NAV_GROUPS = [
  {
    label: "Decision Core",
    items: [
      ["overview", "Command Overview"],
      ["scenarios", "Scenario Compare"],
      ["solar", "Solar Clock"],
      ["bodies", "Body Ledger"],
      ["process", "Process Lab"],
      ["claims", "Claims Register"],
    ],
  },
  {
    label: "Review & Research",
    items: [
      ["formula", "Formula Lab"],
      ["asteroids", "Asteroid Scanner"],
      ["sources", "Source Library"],
      ["packages", "Research Packages"],
      ["roadmap", "Platform Roadmap"],
      ["approval", "Approval Board"],
    ],
  },
];

export function StatStrip({
  evidenceItems,
  confidence,
  artifactAverage,
  openReviewItems,
  exportActions,
}) {
  const cards = [
    ["Kernel mode", "Evidence-first", "green"],
    ["Evidence confidence", `${confidence}%`, confidence > 85 ? "green" : "amber"],
    ["Artifact readiness", `${artifactAverage}%`, artifactAverage > 80 ? "green" : "amber"],
    ["Evidence items", evidenceItems.toLocaleString(), "green"],
    ["Approval state", `${openReviewItems} pending`, "amber"],
  ];

  return (
    <header className="status-strip">
      <span className="build-marker">{BUILD_INFO.id}</span>
      <div className="status-grid">
        {cards.map(([label, value, tone]) => (
          <div className="status-cell" key={label}>
            <StatusGlyph tone={tone} />
            <span>{label}</span>
            <strong className={`tone-${tone}`}>{value}</strong>
          </div>
        ))}
      </div>
      <div className="status-actions">
        {exportActions.map((action) => (
          <JsonExportButton key={action.label} filename={action.filename} createPayload={action.createPayload}>
            {action.label}
          </JsonExportButton>
        ))}
      </div>
    </header>
  );
}

export function SideNav({ activePage, setActivePage, navOpen, setNavOpen, verifiedPercent }) {
  return (
    <aside id="primary-navigation" className={navOpen ? "left-nav nav-open" : "left-nav"}>
      <AppShellLogo />
      {NAV_GROUPS.map((group) => (
        <div className="nav-group" key={group.label}>
          <p className="nav-title">{group.label}</p>
          <div className="nav-list">
            {group.items.map(([id, label]) => (
              <button
                key={id}
                className={activePage === id ? "nav-item nav-item-active" : "nav-item"}
                type="button"
                onClick={() => {
                  setActivePage(id);
                  setNavOpen(false);
                }}
              >
                <span className="nav-icon">
                  <NavGlyph id={id} />
                </span>
                <span>{label}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="left-cta">
        <p>LIVE STATUS</p>
        <strong>{verifiedPercent}%</strong>
        verified and reproducible.
        <small>{BUILD_INFO.id}</small>
      </div>
    </aside>
  );
}
